import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Customized } from 'recharts'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import { Element } from '../../../../../common/html/element'
import { formatByTheme } from '../../../../../helpers/theme'
import { valToPercent } from '../../../../../helpers/value'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { CHARTS } from './constant'
import { selectDataViewByTrend } from './store/slice'

const sbvId = 'SBV'
const valueSbv = 0.08
const carId = 'NB219'

const Trend = ({ isDynamicReport, id, check = [] }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const dataByTrend = useSelector(selectDataViewByTrend)

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const charts = CHARTS.filter(
    ({ dataKey }) => !isDynamicReport || check.includes(dataKey),
  )

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
        width: `calc(100% * ${charts.length / CHARTS.length})`,
      }}
      className="pt2 dFlex"
    >
      {charts.map((chart, index) => {
        const isCar = chart.dataKey === carId

        return (
          <div
            key={index}
            style={{ width: `calc(100% / ${charts.length})` }}
            className="h100 flexColumn"
          >
            <div
              className={`fw600 ${classes.h50px} ${classes.px20} textCenter`}
            >
              <Translate value={chart.title} />
            </div>
            <div className="flex1 minH0">
              <ChartContainer
                data={dataByTrend.map((item) => ({
                  ...item,
                  [sbvId]: valueSbv,
                }))}
                width="100%"
                height="100%"
                margin={{ top: 12, bottom: 0, left: 0, right: 0 }}
                xAxis={[
                  {
                    dataKey: 'year',
                    tickMargin: 3,
                    height: 20,
                    padding: { left: 20, right: 20 },
                    tickFormatter: (value) => '‘' + String(value).slice(-2),
                  },
                ]}
                yAxis={[
                  {
                    yAxisId: 'left',
                    dataKeys: [chart.dataKey].concat(isCar ? [sbvId] : []),
                    isBarChart: true,
                    hide: true,
                  },
                ]}
                tooltip={{
                  schema: {
                    content: [
                      {
                        dataKey: chart.dataKey,
                        label: I18n.t(chart.title),
                        formatValue: (value) => valToPercent(value, locale),
                      },
                    ].concat(
                      isCar
                        ? [
                            {
                              dataKey: sbvId,
                              label: I18n.t('financialAnalysis.SBV_1'),
                              formatValue: (value) =>
                                I18n.t('financialAnalysis.SBV_2') +
                                valToPercent(value, locale),
                            },
                          ]
                        : [],
                    ),
                  },
                }}
              >
                <Bar
                  yAxisId="left"
                  dataKey={chart.dataKey}
                  fill={chart.color}
                  background="#E5E5E8"
                  maxBarSize={35}
                />
                <Customized component={CustomElements} />
                {isCar && <Customized component={CustomLine} />}
              </ChartContainer>
            </div>
          </div>
        )
      })}
    </div>
  )
}

const CustomElements = (props) => {
  const locale = useSelector((state) => state.i18n.locale)
  const bars = props.formattedGraphicalItems?.[0]?.props?.data || []
  const fullBarHeight = props.formattedGraphicalItems?.[0]?.props?.height || 0

  const renderLabels = () => {
    return bars.map(({ x, y, width, value }, index) => {
      const yCoordinate = isNaN(value) ? fullBarHeight - 8 : (y || 0) - 14

      return (
        <g key={index}>
          <foreignObject
            x={x - 100}
            y={yCoordinate}
            height={16}
            width={width + 200}
          >
            <Element
              style={{
                color: '#3A414B',
                fontSize: 10,
                height: '100%',
                width: '100%',
                textAlign: 'center',
              }}
            >
              {valToPercent(value, locale, undefined, undefined, 0)}
            </Element>
          </foreignObject>
        </g>
      )
    })
  }

  return <>{renderLabels()}</>
}

const CustomLine = (props) => {
  const bars = props.formattedGraphicalItems?.[0]?.props?.data || []

  if (!bars.length) {
    return
  }

  const barHasValue = bars.find((bar) => bar[carId])

  if (!barHasValue) {
    return
  }

  const heightLine =
    barHasValue.height * (barHasValue[sbvId] / barHasValue[carId])

  const yLine = barHasValue.height + barHasValue.y - heightLine

  const renderLine = () => {
    return (
      <line
        x1={bars[0].x}
        y1={yLine}
        x2={bars[bars.length - 1].x + bars[0].width}
        y2={yLine}
        stroke={formatByTheme('#F5CBA3')}
        strokeWidth={1}
      />
    )
  }
  return <>{renderLine()}</>
}

export default Trend
